import { render, staticRenderFns } from "./Operaciones-precios-combustibles.vue?vue&type=template&id=4a45122c&scoped=true&"
import script from "./Operaciones-precios-combustibles.vue?vue&type=script&lang=js&"
export * from "./Operaciones-precios-combustibles.vue?vue&type=script&lang=js&"
import style0 from "./Operaciones-precios-combustibles.vue?vue&type=style&index=0&id=4a45122c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a45122c",
  null
  
)

export default component.exports